export const COVER_PAGE = 'coverPage';
export const GAME_PAGE = 'gamePage';
export const SUCCESS_PAGE = 'successPage';
export const FAIL_PAGE = 'failPage';
